import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { GlobalsPermissions } from '@globals/permissions.global';
import { ActivatedRoute } from '@angular/router';
import { ContractsRequests } from '@base/api/contracts/contracts.requests';
import { map, take } from 'rxjs/operators';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  private contractId = '';

  constructor(
    private contractApi: ContractsRequests,
    private authService: AuthService,
    public permissions: GlobalsPermissions,
    private activeRoute: ActivatedRoute,
    private accountService: UserService
  ) { }

  /**
   * Check permissions for account user
   */
  loggedUserPermissions() {
    const user = this.authService.user;
    if (!user.accounts)
      return [];

    const account = user.accounts
      .find(x => this.authService.accountId.toString() === x.accountId.toString());

    const permissions = account ? account.accountPermissions : [];

    return permissions;
  }

  /**
   * Check permissions
   * @param contractId contract id to be checked
   */
  async loggedContractPermissions(lookup) {
    return new Promise((resolve, reject) => {
      if (!lookup)
        return resolve([]);

      this.authService.currentContract
        .pipe(
          take(1),
          map(permissions => this.handleContractPermissions(permissions, lookup))
        )
        .subscribe(
          permissions => resolve(permissions)
        )
        .unsubscribe();
    });
  }

  /**
   * get list of permissions by section type, could be 'account' for
   * account level permissions or 'contract' for contract level permissions
   * @param type section permission type ['account', 'contract']
   * @param [lookup] contract section id
   */
  async getSectionPermissions(type: string, lookup?: any) {
    // this.contractId = contractId;
    const lookupData = lookup;
    if (!type)
      return [];
    const permissions = type === 'account' ? this.loggedUserPermissions() : await this.loggedContractPermissions(lookupData);

    return permissions;
  }

  /**
   * Given section and user permissions, compare if there exist an intersection between one or more items
   * @param sectionPermissions section you want to validate
   * @param userPemissions user permissions
   */
  checkPermissions(sectionPermissions: any, userPemissions: any): Boolean {
    let allowed = false;

    if (!sectionPermissions || !userPemissions)
      return allowed;

    const permissions = [];
    for (const permission of sectionPermissions) {
      const exists = userPemissions
        .find(_permission => {
          const item = this.permissions[permission] || '';
          return _permission.toLowerCase() === item.toLowerCase();
        });

      if (exists)
        permissions.push(permission);
    }

    allowed = permissions.length >= 1;
    return allowed;
  }

  /**
   * If permissions list is not empty return same parmissions
   * otherwise request permissions list
   * @param permissions stored permissions list
   * @param lookup rootContractId
   */
  private handleContractPermissions(permissions, lookup) {
    // if (permissions.length)
    //   return permissions;
    return this.getContractPermissions(lookup);
  }

  /**
   * Request permissions list for a contract
   * @param lookup contract id
   */
  private getContractPermissions(lookup) {
    return new Promise((resolve, reject) => {
      this.contractApi.lookup(lookup).toPromise()
        .then(res => {
          this.accountService.account = res;
          const contractId = res.contract.contractId;
          return this.contractApi.contractPermissions(contractId).toPromise();
        })
        .then(permissions => {
          this.authService.contract = permissions['data'];
          resolve(permissions['data'] || []);
        })
        .catch(err => resolve([]));
    });
  }
}
